import { Badge, Button } from '@ntconsult/aluma-react';
import { useTranslation } from 'react-i18next';

/** `title` é o texto completo quando `text` vem resumido. */
export type FilterChip<K extends string> = { key: K; text: string; title?: string };

type FilterChipListProps<K extends string> = {
  chips: FilterChip<K>[];
  onRemove: (key: K) => void;
  onClear: () => void;
};

/** Chips removíveis dos filtros aplicados e o "Limpar filtros" — usado pelas três telas. */
export function FilterChipList<K extends string>({
  chips,
  onRemove,
  onClear,
}: FilterChipListProps<K>) {
  const { t } = useTranslation('alocacao');
  if (chips.length === 0) return null;

  return (
    // `fieldset` + `legend` dão o nome acessível do grupo.
    <fieldset className="flex min-w-0 flex-wrap items-center gap-2">
      <legend className="sr-only">{t('filtros.aplicados')}</legend>
      {chips.map((chip) => (
        <Badge
          key={chip.key}
          variant="outline"
          className="min-w-0 max-w-full"
          title={chip.title ?? chip.text}
          onRemove={() => onRemove(chip.key)}
          removeLabel={t('filtros.chips.remover', { filter: chip.text })}
        >
          <span className="min-w-0 truncate">{chip.text}</span>
        </Badge>
      ))}
      <Button variant="ghost" size="sm" onClick={onClear}>
        {t('filtros.limpar')}
      </Button>
    </fieldset>
  );
}
